import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Subject, takeUntil, pipe } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { TwoFAService } from './two-fa.service';
import { TechModalDialogResendModel } from '../../../shared/techmodaldialogresend/techmodaldialogresend.model';
import { SessionService } from '@tech-services/session.service';
import { AppConfig } from '@tech-utils/app-config.service';
import { TechDialogsService } from '../../../shared/tech-dialogs.service';
import { CommonService } from '@tech-services/common.service';

@Component({
  selector: 'tech-two-fa',
  templateUrl: './two-fa.component.html',
  styleUrls: ['./two-fa.component.scss']
})
export class TwoFAComponent implements OnInit {
  @ViewChild('code01') code01: ElementRef;
  @ViewChild('code02') code02: ElementRef;
  @ViewChild('code03') code03: ElementRef;
  @ViewChild('code04') code04: ElementRef;
  @ViewChild('code05') code05: ElementRef;
  @ViewChild('code06') code06: ElementRef;
  private unsubscribe$ = new Subject<void>();
  public form: UntypedFormGroup;
  public showVerificationCode:boolean = false;//Muestra la pagina principal
  public showVerificationCodeOK:boolean = false;//Muestra el ok al code
  public showCodeWrong:boolean = false;//Muestra ne la principal el texto cuando el code a fallado
  public forSMS:boolean = true;//Muestra el texto de mail o el texto del sms
  public showTooManyAttempts = false;//Muestra la pantalla de demasiados intentos con el tiempo de espera
  public showProtectText: boolean = false;//Muestra el texto cuando no ha transcurrido todo el tiempo al fallar varias veces
  public showTextResentCode: boolean = false;//Muestra el texto al reenviar el code
  public showBtoCloseModal: boolean = true;
  public showClickResentCode: boolean = true;
  public messageConflict: string;
  public showMessageConflict:boolean = false;
  public showContentinput:boolean = true;
  
  constructor(
    public dialogRef: MatDialogRef<TwoFAComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: UntypedFormBuilder,
    private twoFAService: TwoFAService,
    private sessionService: SessionService,
    private commonService: CommonService,
    private router: Router,
  ) { 
    this.newform();
  }

  ngOnInit(): void {
    this.forSMS = (AppConfig.settings.twoFAMethod == 'SMS')? true: false;
    this.twoFAService.verificationIdSource.next(localStorage.getItem('VerificationId'))
    if(localStorage.getItem('MaxAttempts')) {
      this.showVerificationCode = false;
      this.showProtectText = true;
      localStorage.removeItem('MaxAttempts');
    }else{
      this.showVerificationCode = true;
      this.showProtectText = false;
    }
    this.twoFAService.showBtoCloseModal$
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((result) => {
      setTimeout(() => {
        this.showBtoCloseModal = result;
      });
      if(result==false){
        this.dialogRef.afterClosed().subscribe((res) => {
          this.router.navigate(['/portfolios']);
        });
      }
    })
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }

  public newform() {
    this.form = this.fb.group({
      code01: ['', [Validators.required]],
      code02: ['', [Validators.required]],
      code03: ['', [Validators.required]],
      code04: ['', [Validators.required]],
      code05: ['', [Validators.required]],
      code06: ['', [Validators.required]],
    });
  }

  public keyupcode(event, input) {
    this.showCodeWrong = false;
    this.showTextResentCode = false;
    if (event.target.value !== '') {
      switch (input) {
        case 1:
          this.code02.nativeElement.focus();
          break;
        case 2:
          this.code03.nativeElement.focus();
          break;
        case 3:
          this.code04.nativeElement.focus();
          break;
        case 4:
          this.code05.nativeElement.focus();
          break;
        case 5:
          this.code06.nativeElement.focus();
          break;
        case 6:
          break;
        default:
          break;
      }
      if (this.form.status == 'VALID') {
        this.verificationCode();
      }
    }

    if (event.keyCode == 8) {
      switch (input) {
        case 1:
          this.code01.nativeElement.focus();
          break;
        case 2:
          this.form.get('code01').setValue('');
          this.code01.nativeElement.focus();
          break;
        case 3:
          this.form.get('code02').setValue('');
          this.code02.nativeElement.focus();
          break;
        case 4:
          this.form.get('code03').setValue('');
          this.code03.nativeElement.focus();
          break;
        case 5:
          this.form.get('code04').setValue('');
          this.code04.nativeElement.focus();
          break;
        case 6:
          this.form.get('code05').setValue('');
          this.code05.nativeElement.focus();
          break;
        default:
          break;
      }
    }
  }
  public verificationCode() {
    this.showContentinput = false;
    let code: string =
      this.code01.nativeElement.value +
      this.code02.nativeElement.value +
      this.code03.nativeElement.value +
      this.code04.nativeElement.value +
      this.code05.nativeElement.value +
      this.code06.nativeElement.value;

      this.clearInput();
    this.twoFAService
      .verificationCode(this.commonService.deviceidSource.value, this.commonService.verificationIdSource.value, code, localStorage.getItem('ClientCode'))
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        this.sessionService.clientDataLogin = data;
        this.sessionService.sessionToken = data.access_token;
        localStorage.setItem('SessionClientToken',data.access_token);
        localStorage.setItem('Language', this.sessionService.language);
        localStorage.removeItem('isAdvisor');

        this.showVerificationCodeOK = true;
        this.showVerificationCode = false;
      },
      (err) => {
        this.showContentinput = true;
        switch(err.error.Status){
          case 'OTP_NOK':
            this.showCodeWrong = true;
            this.commonService.verificationIdSource.next(err.error.VerificationId);
            break;
          case 'MAX_ATTEMPTS':
            this.showVerificationCode = false;
            this.showTooManyAttempts = true;
            break;
          case 'CONFLICT':
            this.showVerificationCode = false;
            this.showTooManyAttempts = false;
            this.messageConflict =  err.error.Message;
            this.showMessageConflict =  true;
            break;
          default:
            break;
        }
      }
    );
  }

  public resendCode() {
    this.showVerificationCode = true;
    this.showClickResentCode = false;
    this.showCodeWrong = false;
    this.showMessageConflict = false;
    this.twoFAService
      .resendCode(this.commonService.verificationIdSource.value, localStorage.getItem('ClientCode'))
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        this.showTextResentCode = true;
        setTimeout(()=> { 
          this.showTextResentCode = false;
          this.showClickResentCode = true;
        }, 6000);
        this.commonService.verificationIdSource.next(data.VerificationId);
        this.clearInput();
      },
      (err) => {
        this.clearInput();
        switch(err.error.Status){
          case 'MAX_ATTEMPTS':
            this.showVerificationCode = false;
            this.showTextResentCode = false;
            this.showTooManyAttempts = true;
              break;
          default:
            break;
        }
      }
    );
  }
  public clearInput() {
    this.code01.nativeElement.focus();
    this.form.reset();
  }
  public pastecode(event) {
    event.preventDefault();
    let clipboardData = event.clipboardData;
    let pastedText = clipboardData.getData('text');
    this.form.get('code01').setValue(pastedText.substr(0, 1));
    this.form.get('code02').setValue(pastedText.substr(1, 1));
    this.form.get('code03').setValue(pastedText.substr(2, 1));
    this.form.get('code04').setValue(pastedText.substr(3, 1));
    this.form.get('code05').setValue(pastedText.substr(4, 1));
    this.form.get('code06').setValue(pastedText.substr(5, 1));
    this.code06.nativeElement.focus();
    if (this.form.status == 'VALID') {
      this.verificationCode();
    }
  }

}
